import React from "react";

const changeLabel = (type) => {
  if (type === "drop-sentence") return "Removed";
  if (type === "soften-claim") return "Reworded";
  return "Changed";
};

// Only what Sandy recorded. Diffing the draft would report a human edit as hers.
const MessageChanges = ({ contextCheck, originalMessage, currentMessage }) => {
  const changes = (contextCheck?.adjustments || []).filter(
    (adjustment) => adjustment?.before,
  );
  const editedByHand =
    Boolean(originalMessage) && originalMessage !== currentMessage;

  if (!changes.length && !editedByHand) return null;

  return (
    <div className="space-y-3">
      {changes.length ? (
        <div>
          <p className="text-xs uppercase tracking-wide text-darkgray">
            What Sandy changed
          </p>
          <p className="mb-2 text-xs text-darkgray">
            {changes.length} {changes.length === 1 ? "change" : "changes"}. The
            rest of the message is word for word the same.
          </p>
          <div className="space-y-2">
            {changes.map((change, index) => (
              <div
                key={index}
                className="rounded-md border border-mediumgray p-3"
              >
                <p className="mb-2 text-xs font-semibold">
                  {index + 1}. {changeLabel(change.type)}
                </p>
                <p className="rounded bg-red-50 px-2 py-1 text-sm text-darkergray line-through">
                  {change.before}
                </p>
                {change.after ? (
                  <p className="mt-1 rounded bg-green-50 px-2 py-1 text-sm">
                    {change.after}
                  </p>
                ) : null}
                {change.reason ? (
                  <p className="mt-2 text-xs text-darkgray">
                    <span className="font-semibold">Why:</span> {change.reason}
                  </p>
                ) : null}
                {change.evidence ? (
                  <p className="mt-1 text-xs text-darkgray">
                    <span className="font-semibold">Evidence:</span>{" "}
                    {change.evidence}
                  </p>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {editedByHand ? (
        <div>
          <p className="text-xs uppercase tracking-wide text-darkgray">
            Before it was edited
          </p>
          <pre className="mt-1 max-h-28 overflow-y-auto whitespace-pre-wrap rounded-md border border-mediumgray bg-lightgray p-3 text-xs">
            {originalMessage}
          </pre>
        </div>
      ) : null}
    </div>
  );
};

export default MessageChanges;
